import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function Bonuses() {
  return <section className="w-full bg-ink-900 px-4 py-14 sm:py-20" data-id="element-67" data-mp="1hifyl84wyudv">
      <div className="mx-auto max-w-3xl" data-id="element-68" data-mp="1clpl8skhucw5">
        <p className="flex items-center justify-center gap-2 text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-spark-500" data-id="element-69" data-mp="18jkvi4x620es">
          <GiftIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-70" data-mp="258k3ditu906g" />
          Et en plus, vous recevrez gratuitement
        </p>
        <h2 className="mt-3 text-center font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-71" data-mp="208nyzih8b6qd">
          5 Bonus Exclusifs
        </h2>

        <div className="mt-8 space-y-4" data-id="element-72" data-mp="1r90xkwoi20xb">
          {bonuses.map(b => <article key={b.tag} className="overflow-hidden rounded-2xl border border-spark-500/25 bg-ink-800/70 sm:flex sm:items-center sm:gap-5 sm:p-5" data-id="element-73" data-mp="kujh811njv1l">
              <div className="bg-ink-950/60 px-2 pb-1 pt-3 sm:w-52 sm:shrink-0 sm:rounded-xl sm:px-3 sm:py-3" data-id="element-74" data-mp="1et56so91jr3s">
                <img src={b.image} alt={`Aperçu du bonus : ${b.title}`} className="mx-auto w-full" loading="lazy" data-id="element-75" data-mp="1jszxaqowmeob" />
              </div>

              <div className="flex flex-col px-5 pb-5 pt-4 sm:p-0" data-id="element-76" data-mp="1aqqr2d0o57gq">
                <span className="self-start rounded-md bg-spark-500 px-2 py-1 text-[10px] font-extrabold uppercase tracking-[0.15em] text-ink-950" data-id="element-77" data-mp="w2njx0aw3pqc">
                  {b.tag}
                </span>
                <h3 className="mt-3 text-lg font-extrabold leading-tight text-white" data-id="element-78" data-mp="n30nyu0xjc4o">
                  {b.title}
                </h3>
                <p className="mt-1.5 text-sm leading-snug text-white/65" data-id="element-79" data-mp="r4lxq6i63aan">{b.description}</p>
                <p className="mt-3 text-sm font-bold text-white/45" data-id="element-80" data-mp="d5m7wvix4pcw">
                  Valeur : <span className="line-through decoration-2" data-id="element-81" data-mp="i3nu3pbn54sl">{b.value}</span>{' '}
                  <span className="ml-1 rounded bg-arc-500/15 px-1.5 py-0.5 text-arc-400" data-id="element-82" data-mp="2jsbm0z8zmsbf">
                    Offert aujourd’hui
                  </span>
                </p>
              </div>
            </article>)}
        </div>

        <div className="mt-10" data-id="element-83" data-mp="2b0rq0kvqiwk5">
          <CtaBlock label="Je veux les bonus offerts" data-id="element-84" data-mp="2axvq4r0btxt2" />
        </div>
      </div>
    </section>;
}